module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"secureCheckout":"Secure Checkout","securePayment":"Secure payment","shipping":"Shipping","payment":"Payment","confirmation":"Confirmation"},"de":{"secureCheckout":"Sicherer Bestellprozess","securePayment":"Sichere Bezahlung","shipping":"Versand","payment":"Zahlung","confirmation":"Bestätigung"}}')
  delete Component.options._Ctor
}
